function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48",
  height: "47",
  viewBox: "0 0 48 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M23.67 47a23.5 23.5 0 100-47 23.5 23.5 0 000 47z",
  fill: "#DC4E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.28 24.55a9.68 9.68 0 006.53 9.16c3.61 1.22 8.05.3 10.45-2.78 1.75-2.17 2.15-5.05 1.96-7.75-3.09-.03-6.18-.02-9.27-.01v3.3c1.86.05 3.71.02 5.56.06-.47 1.6-1.53 3.09-3.15 3.67a6.1 6.1 0 01-8.07-3.7 6.13 6.13 0 013.95-7.82c1.99-.7 4.03.09 5.73 1.12.86-.8 1.67-1.66 2.46-2.53a9.69 9.69 0 00-6.96-2.39c-5 .06-9.38 4.68-9.19 9.67z",
  fill: "#DC4E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.28 24.55c-.19-5 4.19-9.61 9.19-9.67a9.69 9.69 0 016.96 2.39c-.8.87-1.6 1.73-2.46 2.53-1.7-1.03-3.74-1.82-5.73-1.12a6.13 6.13 0 00-3.95 7.82 6.1 6.1 0 008.07 3.7c1.62-.58 2.68-2.07 3.15-3.67-1.85-.04-3.7-.02-5.55-.07v-3.3c3.08 0 6.17 0 9.26.02.19 2.7-.2 5.58-1.96 7.75-2.4 3.09-6.84 4-10.45 2.78a9.68 9.68 0 01-6.53-9.16z",
  fill: "#fff"
})));